if(!customElements.get('product-gallery')) {
  customElements.define('product-gallery', class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[data-product-slider]');      
      if(!this.slider) return;
      this.initSlider();
    }

    initSlider() {
      if(window.innerWidth >= 992) return;
      const scrollbar = this.slider.querySelector('.product-gallery--scrollbar');
      const nextButton = this.slider.querySelector('.next-slide-button');
      const prevButton = this.slider.querySelector('.prev-slide-button');
      const videos = this.querySelectorAll('video');
      const options = {
        slidePerView: 1,
        slidePerMove: 1, 
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        scrollbar: {
          el: scrollbar,
          draggable: true,
          dragSize: 'auto',
        },
        on: {
          transitionStart: function() {
            if (videos.length === 0) return;
            this.videos.forEach(video => {
              video.pause();
            });
          },
          transitionEnd: function() {
            const activeSlide = this.slides[this.activeIndex];
            if(!activeSlide) return;
            const activeSlideVideo = activeSlide.querySelector('video');
            if(!activeSlideVideo) return;
            activeSlideVideo.play();          
          }
        }
      }
      const slider = new Swiper(this.slider, options);
    }
  })
}